import Phaser from "phaser";
import { HomeBtn } from "@phaser/ui/btns/HomeBtn";
import { ShareBtn } from "@phaser/ui/btns/ShareBtn";
import { shareGameResult } from "@/utils/shareResult";
import { APP_STORE_URL } from "@/constants/app";

export class GameOverScene extends Phaser.Scene {
  constructor() {
    super("GameOverScene");
  }

  // preload() {
  // }

  create() {
    const { width, height } = this.scale;

    const finalScore = this.registry.get("finalScore") ?? 0;
    const earnedCoins = this.registry.get("earnedCoins") ?? 0;
    const isNewRecord = (this.registry.get("isNewRecord") as boolean) ?? false;
    const scoreText = finalScore.toLocaleString("ko-KR");

    // 배경
    const bg = this.add.image(width / 2, height / 2, "home-bg");
    bg.setDisplaySize(width, height);

    // 어둡기 오버레이
    const overlay = this.add.rectangle(
      width / 2,
      height / 2,
      width,
      height,
      0x000000,
      0.3,
    );
    overlay.setOrigin(0.5);

    // 게임오버
    this.add
      .image(width / 2, (height * 351) / 1366, "gameover-text")
      .setOrigin(0.5);

    // 게임 점수
    this.add
      .text(width / 2, height / 2 - 50, scoreText, {
        fontFamily: "Luckiest Guy",
        fontSize: "200px",
        fontStyle: "normal",
        color: "#FF9A00",
        stroke: "#1C120E",
        strokeThickness: 20,
      })
      .setOrigin(0.5);

    // 신기록이라면 "NEW BEST!" 텍스트 추가
    if (isNewRecord) {
      const newBest = this.add
        .text(width / 2, height * 0.38, "NEW BEST!", {
          fontFamily: "Luckiest Guy",
          fontSize: "60px",
          color: "#FFD93D",
          stroke: "#1C120E",
          strokeThickness: 10,
        })
        .setOrigin(0.5)
        .setScale(0);

      this.tweens.add({
        targets: newBest,
        scale: 1,
        duration: 400,
        ease: "Back.out",
      });
    }

    // ===== 코인 아이콘 + 획득 코인 =====
    const coinY = height * 0.62;

    const coinContainer = this.add.container(width / 2, coinY);

    const icon = this.add.image(0, 0, "coin-icon");
    icon.setScale(0.5);

    const coinText = this.add
      .text(-14, 50, `+${earnedCoins.toLocaleString()}`, {
        fontFamily: "Luckiest Guy",
        fontSize: "60px",
        color: "#FFCC00",
        stroke: "#1C120E",
        strokeThickness: 8,
      })
      .setOrigin(0.5);

    coinContainer.add([icon, coinText]);

    new HomeBtn(this, width - width * 0.72, height - height * 0.12, () => {
      this.scene.start("HomeScene");
    });

    new ShareBtn(
      this,
      width - width * 0.28,
      height - height * 0.12,
      async () => {
        try {
          const res = await shareGameResult({
            score: finalScore,
            url: `${APP_STORE_URL}`,
            text: `내 점수는 ${scoreText} 점이야! 너가 나를 이길 수 있을까?`,
          });
          if (res.mode === "clipboard") {
            console.log("Result copied to clipboard!");
          }
        } catch (e) {
          console.error("Error sharing the game result:", e);
        }
      },
    );
  }
}
